import React from "react";
import Helmet from "react-helmet";
import { useHistory } from "react-router-dom";

import Button from "components/Button";

import useDeskpassRepository from "hooks/useRepository/deskpass";
import useEvent from "hooks/useEvent";

import SessionContext from "context/session";
import NotificationContext from "context/notification";

import routes from "lib/routes";

import * as StyledPage from "pages/styles";

const POLL_INTERVAL_MS = 15000;

const SetupCheckEmailPage = () => {
  const { push: pushRoute } = useHistory();
  const { displayError } = React.useContext(NotificationContext);
  const { currentUser, loadSelf } = React.useContext(SessionContext);

  const [{ loading: resendLoading }, sendEmailConfirmation] =
    useDeskpassRepository(
      (repository) => () =>
        repository.signupEmailVerification.sendSignupEmailVerification(),
      { fireOnMount: false }
    );

  const onResend = useEvent(async () => {
    try {
      await sendEmailConfirmation();
    } catch (err) {
      displayError(err);
    }
  });

  React.useEffect(() => {
    if (currentUser?.signupEmailVerified) {
      pushRoute(routes.reservation);
      return;
    }

    const interval = setInterval(async () => {
      try {
        const { data: user } = await loadSelf();

        if (user?.signupEmailVerified) {
          pushRoute(routes.reservation);
        }
      } catch {
        // Ignore polling errors
      }
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [currentUser?.signupEmailVerified, loadSelf, pushRoute]);

  return (
    <>
      <Helmet>
        <title>Confirm your email | Deskpass Teams</title>
      </Helmet>

      <StyledPage.Container compact>
        <StyledPage.HeaderSection>
          <StyledPage.Header>Confirm your email</StyledPage.Header>

          <StyledPage.Subheader>
            Please confirm your email before continuing with team setup. We sent
            a confirmation link to <strong>{currentUser?.email}</strong>. Check
            your spam folder if you do not see it. The link expires in 72 hours.
          </StyledPage.Subheader>
        </StyledPage.HeaderSection>

        <StyledPage.Actions>
          <Button onClick={onResend} disabled={resendLoading}>
            Resend confirmation email
          </Button>
        </StyledPage.Actions>
      </StyledPage.Container>
    </>
  );
};

export default SetupCheckEmailPage;
